<!--
  - Copyright (c) 2020.
  - Project: Source
  - LastModified: 2/14/20, 3:24 PM
  - Author: diengv < Giáp Văn Điện >
  - Email: diengv@ominext.com
  - File name: news-layout.vue
  - File path: D:/Projects/PMS/Source/Client/vuejs/src/resources/layout/news-layout.vue
  -->

<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'news-layout'
}
</script>

<style scoped>

</style>
